export default __webpack_public_path__ + "static/media/product-12.56173a00.jpg";